import * as angular from "angular";
import * as localforage from "localforage";
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import "./app/ng1/Application";
import "./app/ng1/downgrade";

if (environment.production) {
    enableProdMode();
}

angular.element(document).ready(() => {
    (localforage as any).ready(() => {
        platformBrowserDynamic()
            .bootstrapModule(AppModule)
            .catch(err => console.error(err));
    });
});
